export type DisabledReason = 'noNetwork' | 'aiCapabilityUnavailable' | 'drawerOpen';

export const AI_BUTTON_DISABLED_REASON: {
  noNetwork: 'noNetwork';
  aiCapabilityUnavailable: 'aiCapabilityUnavailable';
  drawerOpen: 'drawerOpen';
} = {
  noNetwork: 'noNetwork',
  aiCapabilityUnavailable: 'aiCapabilityUnavailable',
  drawerOpen: 'drawerOpen',
};

export type AIButtonVariant = 'purple' | 'white';

export const AI_BUTTON_VARIANT: {
  purple: 'purple';
  white: 'white';
} = {
  purple: 'purple',
  white: 'white',
};

export type AIButtonSize = 'S' | 'M' | 'L';

export const AI_BUTTON_SIZE: {
  S: 'S';
  M: 'M';
  L: 'L';
} = {
  S: 'S',
  M: 'M',
  L: 'L',
};

export type AIButtonProps = Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, 'disabled'> & {
  variant?: AIButtonVariant;
  size?: AIButtonSize;
} & ({ disabled: true; disabledReason: DisabledReason } | { disabled?: false; disabledReason?: never });
